import { render, staticRenderFns } from "./IconUsersSolid.vue?vue&type=template&id=30843318"
import script from "./IconUsersSolid.vue?vue&type=script&lang=js"
export * from "./IconUsersSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports